<template>
  <div class="invoice-create">
    <el-page-header @back="$router.push('/list')" content="创建发票" class="page-header" />

    <el-row :gutter="24">
      <!-- 左侧：表单 -->
      <el-col :span="12">
        <el-card class="form-card" shadow="never">
          <el-tabs v-model="activeTab">
            <el-tab-pane label="公司信息" name="company">
              <el-form label-width="120px" size="small">
                <el-form-item label="使用模板">
                  <el-select v-model="selectedTemplateId" placeholder="选择公司模板" clearable style="width:100%" @change="applyTemplate">
                    <el-option label="不使用模板" :value="null" />
                    <el-option v-for="t in companyTemplates" :key="t.id" :label="t.name" :value="t.id" />
                  </el-select>
                  <div class="template-actions">
                    <el-button type="primary" size="mini" @click="saveAsTemplate" :disabled="!form.company_name">保存为模板</el-button>
                    <el-button type="text" size="mini" @click="showTemplateDialog = true">管理模板</el-button>
                  </div>
                </el-form-item>
                <el-form-item label="公司名称">
                  <el-input v-model="form.company_name" placeholder="公司名" />
                </el-form-item>
                <el-form-item label="公司Logo">
                  <el-upload
                    class="logo-uploader"
                    :action="uploadUrl"
                    name="file"
                    :show-file-list="false"
                    :on-success="(res, file) => { if (res.code === 0) form.company_logo = res.data.url }"
                    :on-error="() => $message.error('上传失败')"
                    :before-upload="beforeImageUpload"
                  >
                    <img v-if="form.company_logo" :src="fullImageUrl(form.company_logo)" class="logo-preview-img" />
                    <i v-else class="el-icon-plus logo-uploader-icon" />
                  </el-upload>
                </el-form-item>
                <el-form-item label="公司地址">
                  <el-input v-model="form.company_address" type="textarea" placeholder="街道地址" />
                </el-form-item>
                <el-form-item label="城市">
                  <el-input v-model="form.company_city" placeholder="城市" />
                </el-form-item>
                <el-form-item label="州">
                  <el-input v-model="form.company_state" placeholder="州" />
                </el-form-item>
                <el-form-item label="邮编">
                  <el-input v-model="form.company_zip" placeholder="邮编" />
                </el-form-item>
                <el-form-item label="国家">
                  <el-input v-model="form.company_country" placeholder="国家" />
                </el-form-item>
                <el-form-item label="公司邮箱">
                  <el-input v-model="form.company_email" placeholder="邮箱" />
                </el-form-item>
                <el-form-item label="公司电话">
                  <el-input v-model="form.company_phone" placeholder="电话" />
                </el-form-item>
                <el-form-item label="公司网站">
                  <el-input v-model="form.company_website" placeholder="网站" />
                </el-form-item>
              </el-form>
            </el-tab-pane>

            <el-tab-pane label="收货地址" name="shipping">
              <el-form label-width="120px" size="small">
                <el-form-item>
                  <el-checkbox v-model="sameAsShipping" @change="onSameAsShippingChange">支付信息与收货地址一样</el-checkbox>
                </el-form-item>
                <el-form-item label="收货人姓名">
                  <el-input v-model="form.shipping_name" placeholder="姓名" />
                </el-form-item>
                <el-form-item label="收货人邮箱">
                  <el-input v-model="form.shipping_email" placeholder="邮箱" />
                </el-form-item>
                <el-form-item label="门牌号">
                  <el-input v-model="form.shipping_house_number" placeholder="门牌号" />
                </el-form-item>
                <el-form-item label="街道">
                  <el-input v-model="form.shipping_street" placeholder="街道" />
                </el-form-item>
                <el-form-item label="城市">
                  <el-input v-model="form.shipping_city" placeholder="城市" />
                </el-form-item>
                <el-form-item label="州">
                  <el-input v-model="form.shipping_state" placeholder="州" />
                </el-form-item>
                <el-form-item label="邮编">
                  <el-input v-model="form.shipping_zip" placeholder="邮编" />
                </el-form-item>
                <el-form-item label="国家">
                  <el-input v-model="form.shipping_country" placeholder="国家" />
                </el-form-item>
              </el-form>
            </el-tab-pane>

            <el-tab-pane label="订单信息" name="order">
              <el-form label-width="120px" size="small">
                <el-form-item label="订单编号">
                  <el-input v-model="form.invoice_number" placeholder="如 #1001" />
                </el-form-item>
                <el-form-item label="订单日期">
                  <el-date-picker
                    v-model="form.order_date"
                    type="datetime"
                    placeholder="选择日期时间"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    style="width:100%"
                  />
                </el-form-item>
                <el-form-item label="订单金额">
                  <el-input-number v-model="form.amount" :min="0" :precision="2" style="width:100%" />
                </el-form-item>
                <el-form-item label="快递费用">
                  <el-input-number v-model="form.shipping" :min="0" :precision="2" style="width:100%" />
                </el-form-item>
                <el-form-item label="客户支付金额">
                  <el-input-number v-model="form.paid_by_customer" :min="0" :precision="2" style="width:100%" />
                </el-form-item>
              </el-form>

              <el-divider>商品列表</el-divider>
              <el-button type="primary" size="small" icon="el-icon-plus" @click="addItem">添加商品</el-button>
              <el-table :data="form.items" border size="small" style="margin-top:12px">
                <el-table-column label="商品" min-width="200">
                  <template slot-scope="scope">
                    <div class="item-cell">
                      <el-upload
                        class="product-uploader"
                        :action="uploadUrl"
                        name="file"
                        :show-file-list="false"
                        :on-success="(res, file) => { if (res.code === 0) scope.row.product_logo = res.data.url }"
                        :on-error="() => $message.error('上传失败')"
                        :before-upload="beforeImageUpload"
                      >
                        <img v-if="scope.row.product_logo" :src="fullImageUrl(scope.row.product_logo)" class="product-preview-img" />
                        <i v-else class="el-icon-plus product-uploader-icon" />
                      </el-upload>
                      <el-input v-model="scope.row.product_name" placeholder="商品名" size="mini" style="margin-top:4px" />
                      <el-input v-model="scope.row.product_variant" placeholder="变体" size="mini" style="margin-top:4px" />
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="数量" width="80">
                  <template slot-scope="scope">
                    <el-input-number v-model="scope.row.qty" :min="1" size="mini" @change="calcItem(scope.row)" />
                  </template>
                </el-table-column>
                <el-table-column label="价格" width="100">
                  <template slot-scope="scope">
                    <el-input-number v-model="scope.row.price" :min="0" :precision="2" size="mini" @change="calcItem(scope.row)" />
                  </template>
                </el-table-column>
                <el-table-column label="税率%" width="80">
                  <template slot-scope="scope">
                    <el-input-number v-model="scope.row.tax_rate" :min="0" :max="100" :precision="2" size="mini" @change="calcItem(scope.row)" />
                  </template>
                </el-table-column>
                <el-table-column label="税额" width="90">
                  <template slot-scope="scope">${{ (scope.row.tax_amount || 0).toFixed(2) }}</template>
                </el-table-column>
                <el-table-column label="小计" width="90">
                  <template slot-scope="scope">${{ (scope.row.subtotal || 0).toFixed(2) }}</template>
                </el-table-column>
                <el-table-column label="操作" width="60">
                  <template slot-scope="scope">
                    <el-button type="text" size="mini" @click="removeItem(scope.$index)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>

            <el-tab-pane label="支付信息" name="payment">
              <el-form label-width="120px" size="small">
                <el-form-item label="姓名">
                  <el-input v-model="form.payment_name" placeholder="姓名" />
                </el-form-item>
                <el-form-item label="门牌号">
                  <el-input v-model="form.payment_house_number" placeholder="门牌号" />
                </el-form-item>
                <el-form-item label="街道">
                  <el-input v-model="form.payment_street" placeholder="街道" />
                </el-form-item>
                <el-form-item label="城市">
                  <el-input v-model="form.payment_city" placeholder="城市" />
                </el-form-item>
                <el-form-item label="州">
                  <el-input v-model="form.payment_state" placeholder="州" />
                </el-form-item>
                <el-form-item label="邮编">
                  <el-input v-model="form.payment_zip" placeholder="邮编" />
                </el-form-item>
                <el-form-item label="国家">
                  <el-input v-model="form.payment_country" placeholder="国家" />
                </el-form-item>
              </el-form>
            </el-tab-pane>
          </el-tabs>

          <div class="form-actions">
            <el-button type="warning" @click="saveDraft" :loading="saving">保存草稿</el-button>
            <el-button type="success" @click="saveComplete" :loading="saving">保存并完成</el-button>
            <el-button type="primary" @click="exportPdf" :loading="exporting">导出 PDF</el-button>
          </div>
        </el-card>
      </el-col>

      <!-- 右侧：实时预览 -->
      <el-col :span="12">
        <el-card class="preview-card" shadow="never">
          <div slot="header" class="preview-header">
            <span>发票预览</span>
            <el-radio-group v-model="previewTemplate" size="mini" style="margin-left:16px">
              <el-radio-button label="classic">经典</el-radio-button>
              <el-radio-button label="modern">现代</el-radio-button>
            </el-radio-group>
          </div>
          <div ref="invoicePreview" class="invoice-preview">
            <div ref="invoicePaper" class="invoice-paper" :class="'template-' + previewTemplate">
              <!-- 经典模板 -->
              <table v-if="previewTemplate === 'classic'" class="invoice-table">
                <tr>
                  <td class="logo-cell">
                    <div v-if="form.company_logo" class="logo-box">
                      <img :src="fullImageUrl(form.company_logo)" alt="Logo" crossorigin="anonymous" />
                    </div>
                    <div v-else class="logo-placeholder">LOGO</div>
                  </td>
                  <td class="company-cell">
                    <h1 class="invoice-title">INVOICE</h1>
                    <p class="company-name">{{ form.company_name || '公司名称' }}</p>
                    <p class="company-addr company-addr-wrap">
                      <span class="company-addr-line1">{{ companyAddrLines.line1 }}</span>
                      <br v-if="companyAddrLines.line2" />
                      <span v-if="companyAddrLines.line2" class="company-addr-line2">{{ companyAddrLines.line2 }}</span>
                    </p>
                    <p class="company-contact">{{ form.company_email }} {{ form.company_phone ? '| ' + form.company_phone : '' }}</p>
                    <p class="company-website">{{ form.company_website }}</p>
                  </td>
                </tr>
                <tr class="header-divider"><td colspan="2"></td></tr>
                <tr>
                  <td class="shipping-cell" valign="top">
                    <strong class="classic-section-title">SHIPPING ADDRESS</strong><br/>
                    {{ form.shipping_name }}<br/>
                    {{ form.shipping_email }}<br/>
                    <span class="addr-one-line">{{ shippingAddrFormatted }}</span>
                  </td>
                  <td class="order-details-cell" valign="top">
                    <p><strong>Amount:</strong> ${{ (form.amount || 0).toFixed(2) }}</p>
                    <p><strong>Invoice Number:</strong> {{ form.invoice_number || '-' }}</p>
                    <p><strong>Order Date:</strong> {{ form.order_date || '-' }}</p>
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    <table class="items-table">
                      <thead>
                        <tr>
                          <th>Items</th>
                          <th>Qty</th>
                          <th>Price</th>
                          <th>Tax</th>
                          <th>Tax Amount</th>
                          <th>Subtotal</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, i) in form.items" :key="i">
                          <td>
                            <span v-if="item.product_logo" class="item-img"><img :src="fullImageUrl(item.product_logo)" crossorigin="anonymous" /></span>
                            {{ item.product_name || '商品名' }}
                            <span v-if="item.product_variant">(Variant: {{ item.product_variant }})</span>
                          </td>
                          <td>{{ item.qty || 0 }}</td>
                          <td>${{ (item.price || 0).toFixed(2) }}</td>
                          <td>{{ item.tax_rate ? item.tax_rate + '%' : '-' }}</td>
                          <td>${{ (item.tax_amount || 0).toFixed(2) }}</td>
                          <td>${{ (item.subtotal || 0).toFixed(2) }}</td>
                        </tr>
                      </tbody>
                    </table>
                    <table class="summary-table">
                      <tr><td></td><td class="summary-value"><span class="label">Subtotal:</span> ${{ computedSubtotal.toFixed(2) }}</td></tr>
                      <tr><td></td><td class="summary-value"><span class="label">Shipping:</span> ${{ (form.shipping || 0).toFixed(2) }}</td></tr>
                      <tr><td></td><td class="summary-value"><span class="label">Tax:</span> ${{ computedTax.toFixed(2) }}</td></tr>
                      <tr><td></td><td class="grand-total">Grand total: ${{ computedGrandTotal.toFixed(2) }}</td></tr>
                      <tr><td></td><td class="summary-value"><span class="label">Paid by customer:</span> ${{ (form.paid_by_customer || 0).toFixed(2) }}</td></tr>
                    </table>
                  </td>
                </tr>
                <tr>
                  <td class="payment-cell" valign="top">
                    <strong class="classic-section-title">PAYMENT INFORMATION</strong><br/>
                    {{ form.payment_name }}<br/>
                    <span class="addr-one-line">{{ paymentAddrFormatted }}</span>
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td colspan="2" class="thank-row">
                    <div class="thank-cell">Thank you for your purchase!</div>
                  </td>
                </tr>
              </table>
              <!-- 现代模板 -->
              <table v-else class="invoice-table invoice-table-modern">
                <tr class="modern-header">
                  <td class="modern-header-left">INVOICE</td>
                  <td class="modern-header-right">
                    <div v-if="form.company_logo" class="logo-box"><img :src="fullImageUrl(form.company_logo)" alt="Logo" crossorigin="anonymous" /></div>
                    <div v-else class="logo-placeholder">LOGO</div>
                  </td>
                </tr>
                <tr><td colspan="2" class="modern-divider"></td></tr>
                <tr>
                  <td colspan="2">
                    <div class="modern-section-title">INVOICE TO</div>
                    <div class="modern-invoice-to">
                      <div class="modern-invoice-left">
                        <div class="modern-addr">{{ form.company_name || '公司名称' }}</div>
                        <div class="modern-addr company-addr-wrap">
                          <div>{{ companyAddrLines.line1 }}</div>
                          <div v-if="companyAddrLines.line2">{{ companyAddrLines.line2 }}</div>
                        </div>
                      </div>
                      <div class="modern-invoice-right">
                        <div class="modern-contact-line">Postal Code : {{ form.company_zip || '-' }}</div>
                        <div class="modern-contact-line">Email : {{ form.company_email || '-' }}</div>
                        <div class="modern-contact-line">Phone : {{ form.company_phone || '-' }}</div>
                        <div class="modern-contact-line">Web : {{ form.company_website || '-' }}</div>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr><td colspan="2" class="modern-divider-dotted"></td></tr>
                <tr>
                  <td>
                    <div class="modern-section-title">SHIPPING ADDRESS</div>
                    <div>{{ form.shipping_name }}</div>
                    <div>{{ form.shipping_email }}</div>
                    <div class="addr-one-line">{{ shippingAddrFormatted }}</div>
                  </td>
                  <td class="order-details-cell">
                    <div>Amount : ${{ (form.amount || 0).toFixed(2) }}</div>
                    <div>Invoice Number : {{ form.invoice_number || '-' }}</div>
                    <div>Order Date : {{ form.order_date || '-' }}</div>
                  </td>
                </tr>
                <tr><td colspan="2" class="modern-divider-dotted"></td></tr>
                <tr>
                  <td colspan="2">
                    <table class="items-table items-table-modern">
                      <thead>
                        <tr>
                          <th>Items</th>
                          <th>Qty</th>
                          <th>Price</th>
                          <th>Tax</th>
                          <th>Tax Amount</th>
                          <th>Subtotal</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, i) in form.items" :key="i">
                          <td>
                            <span v-if="item.product_logo" class="item-img"><img :src="fullImageUrl(item.product_logo)" crossorigin="anonymous" /></span>
                            {{ item.product_name || '商品名' }}
                            <span v-if="item.product_variant">(Variant: {{ item.product_variant }})</span>
                          </td>
                          <td>{{ item.qty || 0 }}</td>
                          <td>${{ (item.price || 0).toFixed(2) }}</td>
                          <td>{{ item.tax_rate ? item.tax_rate + '%' : '-' }}</td>
                          <td>${{ (item.tax_amount || 0).toFixed(2) }}</td>
                          <td>${{ (item.subtotal || 0).toFixed(2) }}</td>
                        </tr>
                      </tbody>
                    </table>
                    <div class="modern-payment-summary">
                      <div class="modern-payment-left">
                        <div class="modern-section-title">PAYMENT INFORMATION</div>
                        <div>{{ form.payment_name }}</div>
                        <div class="addr-one-line">{{ paymentAddrFormatted }}</div>
                        <div class="modern-thank">Thank you for your purchase!</div>
                      </div>
                      <div class="modern-summary-right">
                        <div>Subtotal : ${{ computedSubtotal.toFixed(2) }}</div>
                        <div>Shipping : ${{ (form.shipping || 0).toFixed(2) }}</div>
                        <div>Tax : ${{ computedTax.toFixed(2) }}</div>
                        <div>Paid By Customer : ${{ (form.paid_by_customer || 0).toFixed(2) }}</div>
                        <div class="modern-grand-total">Grand Total : ${{ computedGrandTotal.toFixed(2) }}</div>
                      </div>
                    </div>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <!-- 管理公司模板对话框 -->
    <el-dialog title="管理公司模板" :visible.sync="showTemplateDialog" width="500px">
      <el-table :data="companyTemplates" size="small">
        <el-table-column prop="name" label="模板名称" />
        <el-table-column prop="company_name" label="公司" />
        <el-table-column label="操作" width="120">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="applyTemplate(scope.row.id); showTemplateDialog = false">使用</el-button>
            <el-button type="text" size="mini" style="color:#f56c6c" @click="deleteTemplate(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import invoiceApi from '@/api/invoice'
import companyTemplateApi from '@/api/companyTemplate'
import { API_BASE_URL } from '@/config'
import { formatUsAddress, formatCompanyAddressLines } from '@/utils/address'
import html2canvas from 'html2canvas'
import { jsPDF } from 'jspdf'

export default {
  name: 'InvoiceCreate',
  data() {
    return {
      uploadUrl: `${API_BASE_URL}/upload`,
      activeTab: 'company',
      invoiceId: null,
      saving: false,
      exporting: false,
      selectedTemplateId: null,
      companyTemplates: [],
      showTemplateDialog: false,
      previewTemplate: 'classic',
      sameAsShipping: false,
      form: {
        company_name: '',
        company_logo: '',
        company_address: '',
        company_city: '',
        company_state: '',
        company_zip: '',
        company_country: '',
        company_email: '',
        company_phone: '',
        company_website: '',
        shipping_name: '',
        shipping_email: '',
        shipping_house_number: '',
        shipping_street: '',
        shipping_city: '',
        shipping_state: '',
        shipping_zip: '',
        shipping_country: '',
        payment_name: '',
        payment_house_number: '',
        payment_street: '',
        payment_city: '',
        payment_state: '',
        payment_zip: '',
        payment_country: '',
        invoice_number: '#1001',
        order_date: new Date().toISOString().slice(0, 19).replace('T', ' '),
        amount: 0,
        shipping: 0,
        paid_by_customer: 0,
        status: 0,
        items: [
          { product_logo: '', product_name: '', product_variant: '', qty: 1, price: 0, tax_rate: 0, tax_amount: 0, subtotal: 0 }
        ]
      }
    }
  },
  computed: {
    companyAddrFormatted() {
      return formatUsAddress(null, this.form.company_address, this.form.company_city, this.form.company_state, this.form.company_zip, this.form.company_country) || '-'
    },
    companyAddrLines() {
      const { line1, line2 } = formatCompanyAddressLines(
        this.form.company_address,
        this.form.company_city,
        this.form.company_state,
        this.form.company_zip,
        this.form.company_country
      )
      if (!line1 && !line2) return { line1: '-', line2: '' }
      if (!line1 && line2) return { line1: line2, line2: '' }
      return { line1, line2 }
    },
    shippingAddrFormatted() {
      return formatUsAddress(this.form.shipping_house_number, this.form.shipping_street, this.form.shipping_city, this.form.shipping_state, this.form.shipping_zip, this.form.shipping_country) || '-'
    },
    paymentAddrFormatted() {
      return formatUsAddress(this.form.payment_house_number, this.form.payment_street, this.form.payment_city, this.form.payment_state, this.form.payment_zip, this.form.payment_country) || '-'
    },
    computedSubtotal() {
      return this.form.items.reduce((sum, i) => sum + (parseFloat(i.subtotal) || 0), 0)
    },
    computedTax() {
      return this.form.items.reduce((sum, i) => sum + (parseFloat(i.tax_amount) || 0), 0)
    },
    computedGrandTotal() {
      return this.computedSubtotal + (parseFloat(this.form.shipping) || 0) + this.computedTax
    },
    shippingAddrKey() {
      return [this.form.shipping_name, this.form.shipping_house_number, this.form.shipping_street, this.form.shipping_city, this.form.shipping_state, this.form.shipping_zip, this.form.shipping_country].join('|')
    }
  },
  watch: {
    shippingAddrKey() {
      if (this.sameAsShipping) this.syncShippingToPayment()
    },
    computedGrandTotal: {
      handler(v) {
        if (!this.form.paid_by_customer && v > 0) {
          this.form.paid_by_customer = v
        }
        this.form.amount = v
      },
      immediate: true
    }
  },
  created() {
    this.loadCompanyTemplates()
    const id = this.$route.params.id
    if (id) {
      this.loadInvoice(id)
    } else {
      this.form.invoice_number = '#100' + Math.floor(Math.random() * 900 + 100)
    }
  },
  methods: {
    async loadCompanyTemplates() {
      try {
        const res = await companyTemplateApi.list()
        this.companyTemplates = res.data.data || []
      } catch (e) {
        this.companyTemplates = []
      }
    },
    syncShippingToPayment() {
      this.form.payment_name = this.form.shipping_name
      this.form.payment_house_number = this.form.shipping_house_number
      this.form.payment_street = this.form.shipping_street
      this.form.payment_city = this.form.shipping_city
      this.form.payment_state = this.form.shipping_state
      this.form.payment_zip = this.form.shipping_zip
      this.form.payment_country = this.form.shipping_country
    },
    onSameAsShippingChange(checked) {
      if (checked) this.syncShippingToPayment()
    },
    applyTemplate(id) {
      if (!id) return
      const t = this.companyTemplates.find(x => x.id === id)
      if (!t) return
      this.selectedTemplateId = id
      this.form.company_name = t.company_name || ''
      this.form.company_logo = t.company_logo || ''
      this.form.company_address = t.company_address || ''
      this.form.company_city = t.company_city || ''
      this.form.company_state = t.company_state || ''
      this.form.company_country = t.company_country || ''
      this.form.company_email = t.company_email || ''
      this.form.company_phone = t.company_phone || ''
      this.form.company_zip = t.company_zip || ''
      this.form.company_website = t.company_website || ''
    },
    async saveAsTemplate() {
      if (!this.form.company_name) {
        this.$message.warning('请先填写公司名称')
        return
      }
      let name
      try {
        const res = await this.$prompt('请输入模板名称', '保存为模板', {
          confirmButtonText: '保存',
          cancelButtonText: '取消',
          inputValue: this.form.company_name,
          inputPattern: /\S+/,
          inputErrorMessage: '模板名称不能为空'
        })
        name = res.value
      } catch {
        return
      }
      try {
        await companyTemplateApi.save({
          name,
          company_name: this.form.company_name,
          company_logo: this.form.company_logo,
          company_address: this.form.company_address,
          company_city: this.form.company_city,
          company_state: this.form.company_state,
          company_country: this.form.company_country,
          company_email: this.form.company_email,
          company_phone: this.form.company_phone,
          company_zip: this.form.company_zip,
          company_website: this.form.company_website
        })
        this.$message.success('模板保存成功')
        this.loadCompanyTemplates()
      } catch (e) {
        if (e !== 'cancel') this.$message.error(e.response?.data?.msg || '保存失败')
      }
    },
    async deleteTemplate(row) {
      try {
        await this.$confirm('确定删除该模板？', '提示', { type: 'warning' })
        await companyTemplateApi.delete(row.id)
        this.$message.success('已删除')
        this.loadCompanyTemplates()
        if (this.selectedTemplateId === row.id) {
          this.selectedTemplateId = null
        }
      } catch (e) {
        if (e !== 'cancel') this.$message.error('删除失败')
      }
    },
    fullImageUrl(url) {
      if (!url) return ''
      if (url.startsWith('http')) return url
      const base = API_BASE_URL || ''
      const path = url.startsWith('/') ? url.slice(1) : url
      // 通过 API 接口输出图片，自带 CORS，无需改 Nginx
      if (path.startsWith('uploads/')) {
        return base ? `${base}/upload?action=serve&path=${encodeURIComponent(path)}` : url
      }
      return base ? base + '/' + path : '/' + path
    },
    beforeImageUpload(file) {
      const isImage = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'].includes(file.type)
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isImage) {
        this.$message.error('只能上传 JPG/PNG/GIF/WEBP 格式图片')
        return false
      }
      if (!isLt2M) {
        this.$message.error('图片大小不能超过 2MB')
        return false
      }
      return true
    },
    addItem() {
      this.form.items.push({ product_logo: '', product_name: '', product_variant: '', qty: 1, price: 0, tax_rate: 0, tax_amount: 0, subtotal: 0 })
    },
    removeItem(index) {
      this.form.items.splice(index, 1)
    },
    calcItem(row) {
      const qty = parseFloat(row.qty) || 1
      const price = parseFloat(row.price) || 0
      const taxRate = parseFloat(row.tax_rate) || 0
      row.tax_amount = qty * price * taxRate / 100
      row.subtotal = qty * price + row.tax_amount
    },
    buildPayload(isDraft) {
      return {
        ...this.form,
        status: isDraft ? 0 : 1,
        items: this.form.items.map(i => {
          this.calcItem(i)
          return { ...i }
        })
      }
    },
    async saveDraft() {
      await this.doSave(true)
    },
    async saveComplete() {
      await this.doSave(false)
    },
    async doSave(isDraft) {
      this.saving = true
      try {
        const payload = this.buildPayload(isDraft)
        if (this.invoiceId) {
          await invoiceApi.update(this.invoiceId, payload)
          this.$message.success('更新成功')
        } else {
          const res = await invoiceApi.save(payload)
          this.invoiceId = (res.data && res.data.id) || res.data
          this.$router.replace({ name: 'Edit', params: { id: this.invoiceId } })
          this.$message.success('保存成功')
        }
      } catch (e) {
        this.$message.error(e.response?.data?.msg || '保存失败')
      } finally {
        this.saving = false
      }
    },
    async loadInvoice(id) {
      try {
        const res = await invoiceApi.get(id)
        const d = res.data
        this.invoiceId = d.id
        Object.assign(this.form, {
          company_name: d.company_name,
          company_logo: d.company_logo,
          company_address: d.company_address,
          company_city: d.company_city,
          company_state: d.company_state,
          company_country: d.company_country,
          company_email: d.company_email,
          company_phone: d.company_phone,
          company_zip: d.company_zip,
          company_website: d.company_website,
          shipping_name: d.shipping_name,
          shipping_email: d.shipping_email,
          shipping_house_number: d.shipping_house_number,
          shipping_street: d.shipping_street,
          shipping_city: d.shipping_city,
          shipping_state: d.shipping_state,
          shipping_zip: d.shipping_zip,
          shipping_country: d.shipping_country,
          payment_name: d.payment_name,
          payment_house_number: d.payment_house_number,
          payment_street: d.payment_street,
          payment_city: d.payment_city,
          payment_state: d.payment_state,
          payment_zip: d.payment_zip,
          payment_country: d.payment_country,
          invoice_number: d.invoice_number,
          order_date: d.order_date,
          amount: parseFloat(d.amount),
          shipping: parseFloat(d.shipping),
          paid_by_customer: parseFloat(d.paid_by_customer),
          items: (d.items || []).length ? d.items.map(i => ({
            product_logo: i.product_logo,
            product_name: i.product_name,
            product_variant: i.product_variant,
            qty: i.qty,
            price: parseFloat(i.price),
            tax_rate: parseFloat(i.tax_rate),
            tax_amount: parseFloat(i.tax_amount),
            subtotal: parseFloat(i.subtotal)
          })) : [{ product_logo: '', product_name: '', product_variant: '', qty: 1, price: 0, tax_rate: 0, tax_amount: 0, subtotal: 0 }]
        })
        this.$nextTick(() => {
          const sk = [d.shipping_name, d.shipping_house_number, d.shipping_street, d.shipping_city, d.shipping_state, d.shipping_zip, d.shipping_country].join('|')
          const pk = [d.payment_name, d.payment_house_number, d.payment_street, d.payment_city, d.payment_state, d.payment_zip, d.payment_country].join('|')
          this.sameAsShipping = sk === pk && sk !== '||||||'
        })
      } catch (e) {
        this.$message.error('加载失败')
      }
    },
    async exportPdf() {
      const el = this.$refs.invoicePaper
      if (!el) {
        this.$message.error('预览区域未加载')
        return
      }
      this.exporting = true
      try {
        const canvas = await html2canvas(el, {
          scale: 2,
          useCORS: true,
          logging: false,
          backgroundColor: '#ffffff'
        })
        const imgData = canvas.toDataURL('image/png')
        const pdf = new jsPDF('p', 'mm', 'a4')
        const pdfW = pdf.internal.pageSize.getWidth()
        const pdfH = pdf.internal.pageSize.getHeight()
        pdf.addImage(imgData, 'PNG', 0, 0, pdfW, pdfH)
        pdf.save(`invoice-${this.form.invoice_number || 'draft'}.pdf`)
        this.$message.success('PDF 导出成功')
      } catch (e) {
        this.$message.error('导出失败：' + (e.message || '未知错误'))
      } finally {
        this.exporting = false
      }
    }
  }
}
</script>

<style scoped>
.invoice-create { padding: 24px; }
.page-header { margin-bottom: 20px; }
.form-card, .preview-card { margin-bottom: 20px; }
.logo-uploader ::v-deep .el-upload { border: 1px dashed #d9d9d9; border-radius: 6px; cursor: pointer; overflow: hidden; }
.logo-uploader ::v-deep .el-upload:hover { border-color: #409EFF; }
.logo-uploader-icon { font-size: 28px; color: #8c939d; width: 80px; height: 80px; line-height: 80px; text-align: center; display: block; }
.logo-preview-img { width: 80px; height: 80px; display: block; object-fit: contain; }
.product-uploader ::v-deep .el-upload { border: 1px dashed #d9d9d9; border-radius: 4px; cursor: pointer; overflow: hidden; }
.product-uploader ::v-deep .el-upload:hover { border-color: #409EFF; }
.product-uploader-icon { font-size: 20px; color: #8c939d; width: 40px; height: 40px; line-height: 40px; text-align: center; display: block; }
.product-preview-img { width: 40px; height: 40px; display: block; object-fit: contain; }
.item-cell { display: flex; flex-direction: column; gap: 4px; }
.template-actions { margin-top: 8px; }
.form-actions { margin-top: 20px; padding-top: 16px; border-top: 1px solid #eee; }

.preview-card { position: sticky; top: 24px; }
.invoice-preview { display: flex; justify-content: center; padding: 16px; background: #f0f0f0; }
.invoice-paper { width: 210mm; min-height: 297mm; background: #fff; padding: 40px 24px 24px 24px; font-size: 12px; box-shadow: 0 2px 8px rgba(0,0,0,0.1); }
.invoice-table { width: 100%; border-collapse: collapse; }
.invoice-table td { padding: 8px; vertical-align: top; }
.logo-cell { width: 100px; }
.logo-box img { max-width: 80px; max-height: 80px; }
.logo-placeholder { width: 80px; height: 80px; background: #eee; display: flex; align-items: center; justify-content: center; color: #999; font-size: 11px; }
.company-cell { text-align: right; }
.invoice-title { font-size: 24px; margin-bottom: 8px; }
.company-name { font-weight: bold; }
.company-addr, .company-contact, .company-website { color: #444; margin: 4px 0; }
.company-addr-wrap { white-space: normal; word-break: break-word; line-height: 1.5; }
.company-addr-line2 { color: #444; }
.modern-invoice-left .modern-addr.company-addr-wrap > div { margin-bottom: 4px; }
.modern-invoice-left .modern-addr.company-addr-wrap > div:last-child { margin-bottom: 0; }
.header-divider td { border-top: 1px solid #333; padding: 6px 0; }
.shipping-cell { font-size: 12px; line-height: 1.6; }
.payment-cell { font-size: 11px; line-height: 1.6; }
.classic-section-title { font-size: 14px; display: block; margin-bottom: 4px; }
.order-details-cell { text-align: right; font-size: 12px; line-height: 1.6; }
.order-details-cell p { margin: 4px 0; }
.addr-one-line { white-space: nowrap; display: block; }
.items-table { width: 100%; border-collapse: collapse; margin-top: 16px; }
.items-table th, .items-table td { border: 1px solid #999; padding: 8px; text-align: left; }
.items-table th { background: #e8e8e8; }
.item-img { display: inline-block; margin-right: 8px; vertical-align: middle; }
.item-img img { width: 24px; height: 24px; object-fit: cover; border-radius: 4px; }
.summary-table { width: 100%; margin-top: 12px; }
.summary-table td { padding: 4px 0; }
.summary-table td:first-child { width: 70%; }
.summary-value { color: #222; }
.summary-value .label { font-weight: 600; }
.grand-total { background: #000; color: #fff; padding: 8px !important; font-weight: bold; }
.thank-row { padding-top: 100px !important; }
.thank-cell { text-align: right; font-style: italic; color: #444; }

/* 现代模板样式 */
.invoice-table-modern { width: 100%; }
.modern-header { background: #2563eb; color: #fff; }
.modern-header td { padding: 12px 16px; vertical-align: middle; }
.modern-header-left { font-size: 20px; font-weight: bold; }
.modern-header-right { text-align: right; }
.modern-header-right .logo-box img { max-width: 80px; max-height: 48px; }
.modern-header-right .logo-placeholder { width: 80px; height: 48px; background: rgba(255,255,255,0.3); display: inline-flex; align-items: center; justify-content: center; color: #fff; font-size: 11px; }
.modern-divider { height: 4px; background: #2563eb; padding: 0 !important; }
.modern-divider-dotted { border-top: 1px dotted #999; padding: 8px 0 !important; }
.modern-section-title { height: 16px; font-family: Roboto, Roboto; font-weight: 600; font-size: 14px; color: #0059CD; text-align: left; font-style: normal; text-transform: none; margin-bottom: 6px; }
.modern-invoice-to { display: flex; justify-content: space-between; align-items: flex-start; gap: 24px; }
.modern-invoice-left { flex: 1; min-width: 0; }
.modern-invoice-left .modern-addr { margin-bottom: 4px; }
.modern-invoice-right { flex-shrink: 0; text-align: right; }
.modern-contact-line { font-size: 11px; color: #444; margin: 2px 0; white-space: nowrap; }
.items-table-modern { width: 100%; border-collapse: collapse; margin-top: 16px; }
.items-table-modern th { background: #374151; color: #fff; padding: 8px; text-align: left; font-size: 11px; }
.items-table-modern th:first-child { background: #4b5563; }
.items-table-modern th:nth-child(n+2) { background: #2563eb; }
.items-table-modern td { border: 1px solid #e5e7eb; padding: 8px; font-size: 11px; }
.modern-payment-summary { display: flex; justify-content: space-between; margin-top: 16px; padding-top: 12px; }
.modern-payment-left { flex: 1; }
.modern-summary-right { text-align: right; font-size: 11px; line-height: 1.8; }
.modern-grand-total { background: #2563eb; color: #fff; padding: 8px 12px !important; font-weight: bold; margin-top: 8px; display: inline-block; }
.modern-thank { color: #2563eb; font-weight: bold; text-decoration: underline; margin-top: 12px; }
</style>
